export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/8ef8fa070df957526beb6f108087c0f7.png";